import 'twin.macro';
import React from 'react';
import { NumericFormat } from 'react-number-format';

const EURCurrency = ({
  amount,
  fixedDecimalScale,
  className,
}: {
  amount: number;
  fixedDecimalScale?: boolean;
  className?: string;
}) => (
  <span className={className} tw="whitespace-nowrap">
    <NumericFormat
      displayType="text"
      value={amount}
      suffix="&nbsp;€"
      decimalSeparator=","
      thousandSeparator="&nbsp;"
      decimalScale={2}
      fixedDecimalScale={fixedDecimalScale}
    />
  </span>
);

export default EURCurrency;
